module.exports = __webpack_public_path__ + "img/car2.76b812d0.png";